import {
  ApplicationConfig,
  inject,
  Injector,
  LOCALE_ID,
  makeStateKey,
  provideAppInitializer,
  TransferState,
} from '@angular/core';
import {provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling} from '@angular/router';
import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {KeycloakService} from 'keycloak-angular';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideClientHydration, withEventReplay, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {APP_CONFIG, AppConfig} from './app-config.model';
import {IS_MOBILE} from './services/generic.service';
import {UniversalInterceptor} from './services/universal.interceptor';
import {keycloakInitService} from "./services/keycloak-init.service";
import dayjs from "dayjs";
import {RouteAccessibilityService} from './services/route-accessibility.service';
import {EaTitleStrategy} from './services/ea-title.strategy';
import {APP_CONFIG_STATE_KEY, createEmptyAppConfig} from './services/app-config.loader';
import {StartupService} from './services/startup.service';
import {firstValueFrom} from 'rxjs';
import {NavigationScrollService} from './services/navigation-scroll.service';

const CONFIG_KEY = makeStateKey<Partial<AppConfig>>(APP_CONFIG_STATE_KEY);

export const appConfig: ApplicationConfig = {
  providers: [
      provideRouter(routes,
        withComponentInputBinding(),     // auto-bind resolved data/params to @Input()
        withInMemoryScrolling({ scrollPositionRestoration: 'disabled' })
      ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    KeycloakService,
   //TODO spostando all'interno del app.component.ts
     provideAppInitializer(() => {
      const startupService = inject(StartupService);
      const initializerFn = (keycloakInitService)(inject(KeycloakService), inject(Injector));
      // The public session cookie must exist before any component/service call
      // that depends on it (GetCacheData, SetCacheData, ...). Created after Keycloak
      // so the Bearer token is still attached, as in the previous flow.
      return initializerFn().finally(() => firstValueFrom(startupService.load()));
    }),
    provideAppInitializer(() => {
      dayjs.locale('it');
    }),
    provideAppInitializer(() => {
      inject(RouteAccessibilityService).init();
    }),
    provideAppInitializer(() => {
      inject(NavigationScrollService).init();
    }),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
      includePostRequests: true,            // ✅ cache POST
      // Optionally include auth requests:
      includeRequestsWithAuthHeaders: false,
      // Optionally filter which requests are cached:
        filter: req => req.method === 'POST' && req.url.endsWith('/GetPage')
    })),
    {
      provide: APP_CONFIG,
      // Fallback: nel browser main.ts sovrascrive APP_CONFIG con la config risolta prima del bootstrap.
      useFactory: (ts: TransferState) => ts.get(CONFIG_KEY, createEmptyAppConfig()) as AppConfig,
      deps: [TransferState],
    },
    {
      provide: IS_MOBILE,
      useFactory: () => {
        return globalThis.matchMedia('(max-width: 1023px)').matches;
      }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UniversalInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: TitleStrategy, useClass: EaTitleStrategy },
    /*{
      provide: RECAPTCHA_SETTINGS,
      useFactory: () => {
        const state = inject(TransferState);
        const siteKey = state.get(CONFIG_KEY, null);
        return {
          siteKey: siteKey.RECAPTCHA_SITE_KEY
        } as RecaptchaSettings;
      }
    }*/
  ]
};
